"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StellaBIO = void 0;
const DirectHubClient_1 = require("./DirectHubClient");
const FirmwareStorage_1 = require("./FirmwareStorage");
const diffArray = [];
function diff(oldObj, newObj, callback, arr = diffArray) {
    let haveChanges = false;
    for (const prop in newObj) {
        diffArray.push(prop);
        const oldValue = oldObj[prop];
        const newValue = newObj[prop];
        if (typeof oldValue === "object" && typeof newValue === "object") {
            haveChanges = haveChanges || diff(oldValue, newValue, callback, diffArray);
        }
        else if (oldValue !== newValue) {
            const result = callback(oldValue, newValue, diffArray);
            haveChanges = haveChanges || result === undefined || result === true;
        }
        diffArray.pop();
    }
    return haveChanges;
}
const BATTERY_MAX = 8.1;
const BATTERY_MIN = 7.0;
class StellaBIO extends DirectHubClient_1.DirectHubClient {
    constructor(data) {
        super(data);
        this.dataDiffCallback = (oldValue, newValue, property) => {
            StellaBIO.logDiffDebug && console.log(oldValue, newValue, property);
            if (this.waitingPromises.length > 0 && property.length === 1) {
                this.resolveWaitingDispatchers(property[0]);
            }
            if (property[0] === "bat" && property[1] === "vol") {
                // Only check the battery voltage to one decimal place
                // because of frequent voltage fluctuations due to inaccuracy
                return Math.floor(oldValue * 10) !== Math.floor(newValue * 10);
            }
            return true;
        };
        this.waitingPromises = [];
        this._firmwareUpdateVersion = 0;
    }
    get id() {
        return this.serialNumber;
    }
    get batteryVoltage() {
        var _a, _b;
        return (_b = (_a = this.data.bat) === null || _a === void 0 ? void 0 : _a.vol) !== null && _b !== void 0 ? _b : 0;
    }
    get batteryLevel() {
        const A = 100 / (BATTERY_MAX - BATTERY_MIN);
        const B = 0 - A * BATTERY_MIN;
        return Math.min(Math.max(A * this.batteryVoltage + B, 0), 100);
    }
    get osName() {
        var _a, _b;
        return (_b = (_a = this.data.device) === null || _a === void 0 ? void 0 : _a.os.name) !== null && _b !== void 0 ? _b : "";
    }
    get osVersion() {
        var _a, _b;
        return parseInt((_b = (_a = this.data.device) === null || _a === void 0 ? void 0 : _a.os.version) !== null && _b !== void 0 ? _b : "0", 10);
    }
    get serialNumber() {
        var _a;
        return (_a = this.data.sn) !== null && _a !== void 0 ? _a : "";
    }
    get localNetworkConnection() {
        var _a, _b;
        return (_b = (_a = this.data.net) === null || _a === void 0 ? void 0 : _a.local) !== null && _b !== void 0 ? _b : null;
    }
    get mac() {
        var _a, _b;
        return (_b = (_a = this.localNetworkConnection) === null || _a === void 0 ? void 0 : _a.basemac) !== null && _b !== void 0 ? _b : "";
    }
    updateData(data) {
        const haveChanges = diff(this.data, data, this.dataDiffCallback);
        super.updateData(data);
        return haveChanges;
    }
    async updateFirmware(newFirmware) {
        await Promise.all([this.waitFor("mac"), this.waitFor("os")]);
        if (!FirmwareStorage_1.isFirmwareName(this.osName)) {
            throw new Error("Invalid firmware name");
        }
        if (newFirmware.name !== this.osName) {
            throw new Error("Names of the firmwares does not match");
        }
        await newFirmware.storage.updateFirmware(this.osName, this.mac);
        this._firmwareUpdateVersion = newFirmware.version;
    }
    hasFirmwareUpdate(newFirmware) {
        return newFirmware.version > this.osVersion;
    }
    isFirmwareUpdating() {
        return this._firmwareUpdateVersion > this.osVersion;
    }
    waitFor(dataType, timeout = 0) {
        if (dataType === "battery" && this.data.bat) {
            return Promise.resolve();
        }
        if (dataType === "os" && this.data.device) {
            return Promise.resolve();
        }
        if (dataType === "serialNumber" && this.data.sn) {
            return Promise.resolve();
        }
        if ((dataType === "network" || dataType === "mac") && this.data.net) {
            return Promise.resolve();
        }
        const dispatcher = {};
        const promise = new Promise((resolve, reject) => {
            dispatcher.type = dataType === "battery" ? "bat"
                : dataType === "network" || dataType === "mac" ? "net"
                    : dataType === "os" ? "device"
                        : dataType === "serialNumber" ? "sn"
                            : (() => { throw new Error("Invalid data type"); })();
            dispatcher.resolve = resolve;
            dispatcher.reject = reject;
        });
        if (timeout > 0) {
            const timeoutId = globalThis.setTimeout(() => {
                dispatcher.reject("timeout");
            }, timeout);
            const oldResolve = dispatcher.resolve;
            dispatcher.resolve = () => {
                clearTimeout(timeoutId);
                oldResolve();
            };
        }
        this.waitingPromises.push(dispatcher);
        return promise;
    }
    signal(type) {
        if (type === "disconnect") {
            for (let i = 0; i < this.waitingPromises.length; i++) {
                this.waitingPromises[i].reject("disconnect");
            }
        }
    }
    resolveWaitingDispatchers(type) {
        if (this.waitingPromises.length === 0) {
            return;
        }
        for (let i = this.waitingPromises.length - 1; i >= 0; i--) {
            const dispatcher = this.waitingPromises[i];
            if (dispatcher.type === type) {
                dispatcher.resolve();
                this.waitingPromises.splice(i, 1);
            }
        }
    }
}
exports.StellaBIO = StellaBIO;
StellaBIO.logDiffDebug = false;
StellaBIO.DEFAULT_OS_NAME = "BioMea";
//# sourceMappingURL=StellaBIO.js.map